import {Component} from '@angular/core';
import {TranslationService} from '@emma-labs/shared/angular';
import {TreeNode} from 'primeng/api';
import {CardModule} from 'primeng/card';
import {TreeTableModule} from 'primeng/treetable';
import {ReferenceDocumentation} from './reference-documentation';
import {TABLE_CONTENT_EN, TABLE_CONTENT_FR} from './table-content';

@Component({
  selector: 'em-documentation-table',
  templateUrl: './documentation-table.component.html',
  styleUrls: ['./documentation-table.component.scss'],
  imports: [CardModule, TreeTableModule],
})
export class DocumentationTableComponent {
  tableContent: TreeNode[];

  constructor(private readonly translation: TranslationService) {
    this.tableContent = this.translation.currentLanguageIsFr() ? TABLE_CONTENT_FR : TABLE_CONTENT_EN;
  }

  openPdf(referenceDocumentation: ReferenceDocumentation): void {
    const pathToFile = `assets/reference-documents/${referenceDocumentation}`;
    window.open(pathToFile, '_blank');
  }

  openWebsite(href: string): void {
    window.open(href);
  }
}
